














import { Component, Prop, Vue } from 'vue-property-decorator';
import VueGallery from 'vue-gallery';
import Picture from '@/entities/Picture';

@Component({
    components: {
        VueGallery,
    },
})
export default class Gallery extends Vue {
    @Prop()
    pictures: Picture[];

    @Prop({ default: false })
    displayFirst: boolean;

    index: number = null;

    get galleryPictures(): string[] {
        return [...this.pictures].map((picture: Picture) => picture.url);
    }

    get first(): Picture {
        return this.pictures[0];
    }

    show(index = 0) {
        this.index = index;
    }

    hide() {
        this.index = null;
    }
}
